const openFilter = () => {
    const filterOpen = document.querySelector('.products-filters__title');
    if(filterOpen ) {
        let executive = false
        filterOpen.addEventListener('click', (e) => {
            e.preventDefault();

            if(document.documentElement.clientWidth < 992) {
                if(!executive) {
                    filterOpen.parentElement.parentElement.nextElementSibling.style.display = 'block';
                    filterOpen.parentElement.parentElement.nextElementSibling.nextElementSibling.style.display = 'block';
                    return executive = true
                } else {
                    filterOpen.parentElement.parentElement.nextElementSibling.nextElementSibling.style.display = 'none';
                    filterOpen.parentElement.parentElement.nextElementSibling.style.display = 'none';
                    return executive = false
    
                }
            } else {
                filterOpen.parentElement.parentElement.nextElementSibling.style.display = 'block';
                filterOpen.parentElement.parentElement.nextElementSibling.nextElementSibling.style.display = 'block';
            }
            window.addEventListener('resize', ()=> {
                if(document.documentElement.clientWidth >= 992) { 
                    filterOpen.parentElement.parentElement.nextElementSibling.style.display = 'block';
                    filterOpen.parentElement.parentElement.nextElementSibling.nextElementSibling.style.display = 'block';
                }
            })
            
        })
    }
}  

export default openFilter;